<div class="container">
  <app-alert [show]="showMessage"
             [autohide]="autohideDelay"
             [type]="alertMessage?.type"
             [message]="alertMessage?.text"
             (closeAlert)="showMessage = false"
  ></app-alert>

  <form [formGroup]="form" class="form">
      <app-input [type]="'number'"
        [label]="'API Key'"
        [errorMessage]="'Must be 7 digits'"
        [minlength]="7"
        [maxlength]="7"
        formControlName="apiKey"
        #apiKeyInput
      ></app-input>
  
      <div class="help-container">
        <a class="help-link" (click)="showHelp()">
          How do I get my LibertyRx API Key?
        </a>
      </div>
  </form>

  <div *ngIf="progress === PharmacyManagementSystemIntegrationStepsEnum.PendingConnection" class="controls">
    <app-button customClasses="w-full" 
                text="Test Connection"
                class="next"
                [disabled]="form.invalid || (loading$ | async)"
                (clicked)="testConnection()"
                [loading]="loading$ | async"
                #testConnectionButton
    >
    </app-button>
    <app-button 
                customClasses="w-full"
                subStyle="transparent"
                class="back"
                (clicked)="back.emit(PharmacyManagementSystemIntegrationStepsEnum.SelectType)"
                [disabled]="loading$ | async"
    >
      <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
      Back
    </app-button>
  </div>

  <div *ngIf="progress === PharmacyManagementSystemIntegrationStepsEnum.Finish" class="controls">
    <app-button customClasses="w-full"
                text="Finish"
                class="next"
                (clicked)="finishConnection()"
                [disabled]="loading$ | async"
                [loading]="loading$ | async"
    >
    </app-button>
    <app-button customClasses="w-full"
                subStyle="transparent"
                class="back"
                (clicked)="backToConnection()"
                [disabled]="loading$ | async"
    >
      <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
      Back
    </app-button>
  </div>
</div>